import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { PublishProgressIcon } from './PublishProgressIcon';
import { StatusIndicator } from './StatusIndicator';

export const PublishedBadge: FunctionComponent<{ readonly isActive: boolean; readonly size?: 'sm' | 'md' }> = ({
    isActive,
    size = 'sm',
}) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <StatusIndicator
            className={isActive ? 'text-white-200' : 'text-success-300'}
            data-testid="review-state-published"
            icon={
                <PublishProgressIcon
                    colorBase="currentColor"
                    colorFill="currentColor"
                    isActive={isActive}
                    progress={1}
                />
            }
            size={size}
        >
            {translate('pages.job-architecture-v2.review-state.published')}
        </StatusIndicator>
    );
};
